"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
document.addEventListener("DOMContentLoaded", function () {
  function initExpandOnClick(target, items) {
    if (target.closest(".omd-header-nav-list-item")) {
      var activeItem = target.closest(".omd-header-nav-list-item");
      if (activeItem && !activeItem.children[0].querySelector(".omd-header-acc-btn.hidden")) {
        activeItem.classList.toggle("expanded");
        activeItem.parentNode.classList.toggle("expanded");
      }
      items.forEach(function (item) {
        return item.classList.remove("active");
      });
      activeItem.classList.add("active");
      if (!activeItem.classList.contains("expanded")) {
        items.forEach(function (item) {
          return item.classList.remove("active");
        });
        // initiallyActive.classList.add("active");
      }
    }
  }

  (function openCloseMenuDropdowns() {
    var menu = document.querySelector(".omd-site-nav");
    if (menu) {
      var current = menu.querySelector(".omd-header-nav-list-item.current");
      var listItems = menu.querySelectorAll(".omd-header-nav-list-item");

      // const initiallyActive = menu.querySelector(
      //   ".omd-header-nav-list-item.active"
      // );

      if (listItems.length) {
        var itemWithoutChilds = _toConsumableArray(listItems).filter(function (item) {
          return !item.querySelector(".omd-header-nav-list");
        });
        if (itemWithoutChilds) {
          _toConsumableArray(itemWithoutChilds).forEach(function (item) {
            var accBtn = item.querySelector(".omd-header-acc-btn");
            accBtn.classList.add("hidden");
          });
        }
        _toConsumableArray(listItems).forEach(function (item) {
          if (item.contains(current)) {
            item.classList.add("expanded");
          }
        });
        menu.addEventListener("click", function (e) {
          initExpandOnClick(e.target, listItems);
        });
      }
    }
  })();

  // window.addEventListener("resize", () => {
  //   if (window.innerWidth < 1140) {
  //     const siteNav = document.querySelector(".omd-site-nav");

  //     if (siteNav) {
  //       const activeLi = siteNav.querySelector(
  //         ".omd-header-nav-list-item.active"
  //       );

  //       const activeLink = activeLi.querySelector("a");

  //       const activeText = activeLink.textContent;

  //       const headerNav = document.querySelector(".omd-header-nav");

  //       const links = headerNav.querySelectorAll(".omd-header-nav-link");

  //       const headerNavLi = activeHeaderLink.parentNode.parentNode;

  //       headerNavLi.classList.add("active");

  //       const activeList = headerNavLi.parentNode;

  //       const maxLevel = activeList.dataset.level;

  //       const activeHeaderLink = [...links].find((item) => {
  //         return (
  //           item.textContent.trim().replace(/\s/g, "") ===
  //             activeText.trim().replace(/\s/g, "") &&
  //           activeHeaderLink.parentNode.parentNode.parentNode.dataset.level ===
  //             maxLevel
  //         );
  //       });

  //       const headerNavLists = headerNav.querySelectorAll(
  //         ".omd-header-nav-list"
  //       );
  //       const headerNavItems = headerNav.querySelectorAll(
  //         ".omd-header-nav-list-item"
  //       );

  //       headerNavLists.forEach((item) => {
  //         if (item.dataset.level <= maxLevel) {
  //           item.classList.add("expanded");
  //         }
  //       });

  //       headerNavItems.forEach((item) => {
  //         if (item.contains(activeList)) {
  //           if (item.querySelector(".omd-header-nav-list")) {
  //             item.classList.add("expanded");
  //           } else {
  //             item.classList.add("active");
  //           }
  //         }
  //       });
  //     }
  //   }
  // });
});